module.exports = __webpack_public_path__ + "img/Taiwan-2.2a3fb605.jpg";